import React, { useState } from "react";
import colors from "../config/colors";

// eslint-disable-next-line import/no-anonymous-default-export
export default function ({
  round = true,
  text = "W",
  value,
  onClick,
  forceChecked,
  backgroundColor,
  defaultValue,
  linkChecked,
  style,
  manual,
}) {
  const [checked, setChecked] = useState(forceChecked || defaultValue || false);

  const handleClick = () => {
    if (manual) {
      onClick && onClick(value);
      return false;
    }

    onClick && onClick(value, !checked);
    if (!forceChecked) setChecked(!checked);
  };
  return (
    <div
      onClick={!linkChecked && handleClick}
      style={{
        ...checkbox.wrapper,
        borderRadius: round ? "50%" : 3,

        backgroundColor: backgroundColor
          ? backgroundColor
          : linkChecked || checked
          ? colors.primary
          : "transparent",
        color: linkChecked || checked ? "white" : "silver",
      }}
    >
      <div
        style={{
          height: 35,
          width: 35,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {text}
      </div>
    </div>
  );
}
const checkbox = {
  wrapper: {
    cursor: "pointer",
    border: "1px solid silver",

    fontSize: 17,
    padding: 5,
  },
};
